// extracted by mini-css-extract-plugin
module.exports = {"searchIcon":"styles_searchIcon__2dgxr"};